import config from 'teacher-ui-client/config/environment'
import { shuffle } from 'lodash'
import { join } from 'teacher-ui-client/utils/uri'
import { Product } from 'teacher-ui-client/utils/products'
import {
  recentWritingEWIData,
  recentWritingLessonData,
  recentWritingPlacementData,
  recentWritingLongWritesData,
} from 'teacher-ui-client/mirage/fixtures/writing-legends/recent-writing'

import { longWritesCatalogueData } from 'teacher-ui-client/mirage/fixtures/writing-legends/long-writes'

import { ewiActivityData, ewiActivityFixtures } from 'teacher-ui-client/mirage/fixtures/writing-legends/ewi-activity'

import {
  vocabularyNewWords,
  vocabularyOverusedWordsAnalyserData,
  vocabularyOverusedWords,
  vocabularyLanguageGemsAnalyserData,
} from 'teacher-ui-client/mirage/fixtures/writing-legends/vocabulary'

import {
  ewiCatalogueForAssignmentsData,
  ewiCatalogueData,
} from 'teacher-ui-client/mirage/fixtures/writing-legends/exciting-writing-ideas'

import { longWritesAssignmentActivities } from 'teacher-ui-client/mirage/fixtures/writing-legends/long-writes'

import {
  ewiSubmissionData,
  wlStudentProfileData,
  ewiFeedbacksData,
  longWriteResultData,
  longWriteSubmissionData,
} from 'teacher-ui-client/mirage/fixtures/writing-legends/submissions'

const { writingLegendsApiUrl, lessonsApiV1Url } = config

function setReportingEndpoint(server, ep) {
  const wlUrl = join(writingLegendsApiUrl, '').href

  Object.entries(ep.scopes).forEach(([scope, scopeData]) => {
    server.get(`${wlUrl}/reporting/${scope}/:scope_id/${ep.product}/${ep.reportName}`, function (_schema, request) {
      let epData = scopeData
      if (ep.options?.filterFn && request.queryParams && typeof request.queryParams === 'object') {
        epData = ep.options.filterFn(request.queryParams, epData)
      }
      let meta
      // standard page meta
      if (ep.options?.withPageMeta) {
        meta = {
          page_number: 1,
          page_size: 44,
          total_entries: 88,
          total_pages: 2,
        }
      }
      return {
        ...epData,
        meta,
      }
    })
  })
}

export function setWritingLegendsEndpoints(server) {
  // Recent Writing - EWI
  server.get(`${writingLegendsApiUrl}v1/retui/school/:school_id/ewi_recent_writing`, (schema, req) => {
    const recentWritingData =
      req.queryParams.template === 'long-write' ? recentWritingLongWritesData : recentWritingEWIData

    recentWritingData.reflectionDisappointedCount = Math.floor(Math.random() * 10)
    recentWritingData.reflectionSmileCount = Math.floor(Math.random() * 10)
    recentWritingData.reflectionUnsureCount = Math.floor(Math.random() * 10)
    recentWritingData.recent_writing = shuffle(recentWritingData.recent_writing)
    return recentWritingData
  })

  // Recent Writing - Lesson
  server.get(`${writingLegendsApiUrl}v1/retui/school/:school_id/lessonwriting`, () => {
    return recentWritingLessonData
  })

  server.get(`${writingLegendsApiUrl}v1/retui/school/:school_id/placement_writing`, () => {
    return recentWritingPlacementData
  })

  // Long Writes

  server.get(`${writingLegendsApiUrl}v1/retui/longwritescatalogue`, () => {
    return longWritesCatalogueData
  })

  server.get(`${writingLegendsApiUrl}v1/retuiewi/activities/:activity_id`, (_schema, request) => {
    return ewiActivityFixtures[request.params.activity_id] ?? ewiActivityData
  })

  // Long Writes - Assignment Activities
  server.get(`${lessonsApiV1Url}writing_legends/long_writes`, () => {
    return longWritesAssignmentActivities
  })

  // Exciting Writing Ideas - Catalogue for Assignments
  server.get(`${lessonsApiV1Url}writing_legends/exciting_writing_ideas`, () => {
    return ewiCatalogueForAssignmentsData
  })

  // Exciting Writing Ideas - Catalogue
  server.get(`${writingLegendsApiUrl}v1/views/EWI/activity_catalogue`, () => {
    return ewiCatalogueData
  })

  // Exciting Writing Ideas and Long Writes - Submission/Snapshot
  server.get(`${writingLegendsApiUrl}v1/ewi/:student_id/snapshots/:snapshot_id`, (_schema, request) => {
    if (request.params.snapshot_id.includes('lw_')) {
      return longWriteSubmissionData
    }
    return ewiSubmissionData
  })

  // Get Long Writes Result
  server.get(`${writingLegendsApiUrl}v1/retui/school/:school_id/long-writes/:activity_id/results/:result_id`, () => {
    return longWriteResultData
  })

  // WL - Get Feedbacks
  server.get(`${writingLegendsApiUrl}v1/ewi/:student_id/results/:result_id/feedbacks`, () => {
    return ewiFeedbacksData
  })

  // WL - Post Feedback
  server.post(`${writingLegendsApiUrl}v1/ewi/:student_id/results/:result_id/snapshots/:snapshot_id/feedbacks`, () => {
    return new Response(200, {}, {})
  })

  // WL - Student Profile
  server.get(`${writingLegendsApiUrl}v1/students/:student_id`, () => {
    return wlStudentProfileData
  })

  const endpoints = [
    {
      reportName: 'vocabulary/new-words',
      product: Product.WL,
      scopes: {
        'school-class': vocabularyNewWords,
      },
      options: { withPageMeta: true },
    },
    {
      reportName: 'vocabulary/language-gems',
      product: Product.WL,
      scopes: {
        'school-class': vocabularyNewWords,
      },
      options: { withPageMeta: true },
    },
    {
      reportName: 'vocabulary/overused-words',
      product: Product.WL,
      scopes: {
        'school-class': vocabularyOverusedWords,
      },
    },
    {
      reportName: 'vocabulary/overused-words-analyser',
      product: Product.WL,
      scopes: {
        'school-class': vocabularyOverusedWordsAnalyserData,
      },
      options: { withPageMeta: true },
    },
    {
      reportName: 'vocabulary/language-gems-analyser',
      product: Product.WL,
      scopes: {
        'school-class': vocabularyLanguageGemsAnalyserData,
      },
      options: { withPageMeta: true },
    },
  ]

  endpoints.forEach((ep) => setReportingEndpoint(server, ep))
}
